import React from 'react';
import { AlcoholPercentage } from '../../components/commerce/parts';
import { LinkStyled, Span } from '../../components/typography';
import { Tr, Td } from '../../components/tables';
import { Money } from '../../containers/commerce';
import { LiterFormat } from '../../components/Format';
import { sanitizePrice } from '../../lib/price';
import { sanitizeMeasurement, ScreenSizeDetector } from '../../lib/helpers';

export default (props) => {
  const {
    name,
    price,
    liter,
    fadoelsType,
    land,
    landKort,
    fadKobling,
    alcoholPercentage,
    url,
  } = props;
  return (
    <Tr to={url}>
      <Td>
        {url
          ? (
            <LinkStyled to={url}>
              {name}
            </LinkStyled>
          )
          : name
        }
      </Td>
      <Td textRight>
        <ScreenSizeDetector hide={[[575, true], false]}>
          <Span><Money money={price} /></Span>
        </ScreenSizeDetector>
        <ScreenSizeDetector hide={[[575, false], true]} block={[[575, true], false]}>
          <Span><Money money={price} noDecimal noSuffix />,-</Span>
        </ScreenSizeDetector>
      </Td>
      <Td textRight>
        <ScreenSizeDetector hide={[[991, true], false]}>
          <Span><LiterFormat liter={liter} noSuffix /> liter</Span>
        </ScreenSizeDetector>
        <ScreenSizeDetector hide={[[991, false], true]} block={[[991, true], false]}>
          <Span><LiterFormat liter={liter} noSuffix />l</Span>
        </ScreenSizeDetector>
      </Td>
      <ScreenSizeDetector hide={[[767, true], false]}>
        <Td>
          {fadoelsType}
        </Td>
      </ScreenSizeDetector>
      <ScreenSizeDetector hide={[[767, true], false]}>
        <Td>
          <ScreenSizeDetector hide={[[991, true], false]}>
            <Span>{land}</Span>
          </ScreenSizeDetector>
          <ScreenSizeDetector hide={[[991, false], true]} block={[[991, true], false]}>
            <Span>{landKort}</Span>
          </ScreenSizeDetector>
        </Td>
      </ScreenSizeDetector>
      <ScreenSizeDetector hide={[[575, true], false]}>
        <Td textRight>
          {fadKobling.substring(0, 1)}
        </Td>
      </ScreenSizeDetector>
      <ScreenSizeDetector hide={[[575, true], false]}>
        <Td textRight>
          <AlcoholPercentage value={alcoholPercentage} />
        </Td>
      </ScreenSizeDetector>
      <ScreenSizeDetector hide={[[575, true], false]}>
        <Td textRight>
          <Money money={sanitizePrice(price) / sanitizeMeasurement(liter)} />
        </Td>
      </ScreenSizeDetector>
    </Tr>
  );
};
